<template>
  <div>
    <dialogos-app :dialogos="dialogos" @update:currentText="currentText = $event, $refs.audioPlayer.playAudio($event)"></dialogos-app>
    <transition name="custom" enter-active-class="animated zoomIn" leave-active-class="animated zoomOut" mode="out-in">
      <div class="text-xs-center" key="item1" v-if="currentText == 0">
        <img src="../../assets/presentacion/diapositiva-5.png" alt="petrolera">
      </div>
      <v-layout key="item2" v-else>
        <v-flex v-for="i in 3" :key="'trofeo'+i" xs4 px-1 text-xs-center>
          <button class="hvr hvr-scale" @click="$set(vistos,i - 1,true)">
            <img class="animated zoomIn" :class="'dura-'+i" :src="require('../../assets/presentacion/diapositiva-5-'+i+'.png')" alt="Trofeo">
          </button>
          <p class="texto1 " v-if="vistos[i-1]"><span v-html="textos[i-1]"></span></p>
        </v-flex>
      </v-layout>
    </transition>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Presentacion/AUDIO 12',
    'Presentacion/AUDIO 13',
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "Y para ti, ¿qué significa ésta noticia? Esto es muy importante ya que las reservas le permiten a Ecopetrol S.A buscar negocios a largo plazo y aportar al desarrollo del país.  Por ello, es crucial que te apropies de los conocimientos que adquirirás en cada módulo." ,
        "Al finalizar cada módulo obtendrás un trofeo de bronce, plata u oro, según tus resultados en cada actividad evaluativa. Si logras un trofeo de oro en todos los módulos, al finalizar el curso, obtendrás un objeto especial. ¡Es hora de iniciar! <span class='instruccion'>haz clic en los trofeos.</span>"
      ],
      currentText: 0,
      vistos: Array(3).fill(false),
      textos: [
        "<strong>Oro:</strong> si respondes el 100 % de todas las preguntas correctamente.",
        "<strong>Plata:</strong> si alcanzas un 75 % de acierto en las preguntas.",
        "<strong>Bronce:</strong> si solo respondes la mitad de las preguntas correctamente",
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      if(newValue.every(el => {return el;})){
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
